import { render, staticRenderFns } from "./OrderPrintLabel.vue?vue&type=template&id=1f86da77&scoped=true&"
import script from "./OrderPrintLabel.vue?vue&type=script&lang=js&"
export * from "./OrderPrintLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f86da77",
  null
  
)

export default component.exports